import { render } from "./Q3DetailleOptionB.vue?vue&type=template&id=a6126236"
import script from "./Q3DetailleOptionB.vue?vue&type=script&lang=js"
export * from "./Q3DetailleOptionB.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__